export default ({ request }) => ({

  infoParticipantListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoParticipant/list',
      method: 'post',
      data
    })
  },
  infoParticipantSaveApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoParticipant/update',
      method: 'post',
      data
    })
  },
  infoParticipantAddApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoParticipant/add',
      method: 'post',
      data
    })
  },
  infoParticipantDelApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoParticipant/del',
      method: 'post',
      data
    })
  }
})
